import { createFileRoute, redirect } from '@tanstack/react-router';
import { headSignupSubRoute } from 'router/utils';

import { readOppFlowFlags } from 'router/loaders/utils/oppFlowFlags';
import { isVerified } from 'services/partnersSelfSignup/otp';
import {
  getOppByIdQueryOptions,
  getOppSummaryQueryOptions,
} from 'services/partnersSelfSignup/opportunity';

export const Route = createFileRoute(
  '/opportunity/$oppId/terms-and-conditions/decline/',
)({
  head: headSignupSubRoute,
  beforeLoad: async ({ context, params }) => {
    const { queryClient, growthbook } = context;
    const { oppId } = params;

    const summary = await queryClient.query(
      getOppSummaryQueryOptions({ oppId }),
    );

    if (!(await isVerified({ queryClient, email: summary.oppEmail }))) {
      throw redirect({
        to: '/opportunity/$oppId/email-validation',
        params: { oppId },
      });
    }

    const { opp } = await queryClient.query(
      getOppByIdQueryOptions({ oppId, ...readOppFlowFlags(growthbook) }),
    );

    // An internal "reset contract" can restore decision to 'no_decision'
    // while typeAccess stays 'view'; gate on both so decline stays read-only.
    if (opp.decision !== 'no_decision' || opp.typeAccess === 'view') {
      throw redirect({
        to: '/opportunity/$oppId/terms-and-conditions',
        params: { oppId },
      });
    }
  },
});
